import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-wrapper py-5 bg-light">
            <Container className="bg-white shadow-sm rounded-4 p-4 p-md-5 my-5">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1 className="display-5 fw-bold text-primary-blue mb-4">Privacy Policy</h1>
                    <p className="text-muted">Last Updated: January 2026</p>
                    <hr className="my-4" />

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">1. Introduction</h2>
                        <p>
                            Welcome to <strong>CPR Constructions</strong>. This Privacy Policy applies to our main corporate 
                            website and all project landing pages, including <strong>CPR Cosmos, CPR Park Heights, </strong> 
                            and <strong>CPR Mangala</strong>. We are committed to protecting your personal information 
                            and your right to privacy regarding your interest in our residential projects in Tirupati.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">2. Information We Collect</h2>
                        <p>We collect personal information that you voluntarily provide to us when expressing an interest in obtaining information about our projects. This includes:</p>
                        <ul>
                            <li><strong>Identity Data:</strong> Name and contact preferences.</li>
                            <li><strong>Contact Data:</strong> Email address, phone number, and mailing address.</li>
                            <li><strong>Project Preferences:</strong> Specific interest in 2BHK/3BHK units or specific project locations (Renigunta Road, Mangalam, etc.).</li>
                        </ul>
                    </section>

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">3. How We Use Your Information</h2>
                        <p>We use the information collected via our website for several business purposes:</p>
                        <ul>
                            <li>To send you project brochures, floor plans, and pricing for the specific project you inquired about.</li>
                            <li>To facilitate site visits and direct communication with our sales team.</li>
                            <li>To comply with <strong>RERA (Real Estate Regulatory Authority)</strong> documentation and lead transparency requirements.</li>
                        </ul>
                    </section>

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">4. Project-Specific Disclosures</h2>
                        <p>Our website features three distinct RERA-registered projects. Data collected on specific sections is handled in accordance with the following registrations:</p>
                        <ul>
                            <li><strong>CPR Mangala:</strong> RERA No. P10110065222</li>
                            <li><strong>CPR Cosmos:</strong> RERA No. P10110064560</li>
                            <li><strong>CPR Park Heights:</strong> RERA No. P10110064321</li>
                        </ul>
                    </section>

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">5. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational security measures designed to protect the 
                            security of any personal information we process. However, please also remember that we cannot 
                            guarantee that the internet itself is 100% secure.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h2 className="h4 fw-bold mb-3">6. Contact Us</h2>
                        <p>
                            If you have questions or comments about this policy, you may contact our corporate office in 
                            Tirupati or email us at <strong>info.cpr369@gmail.com</strong>.
                        </p>
                    </section>
                </motion.div>
            </Container>
        </div>
    );
};

export default PrivacyPolicy;